<template>
  <div class="SettingDialog">
    <el-dialog
      class="customDialog"
      :title="dialogTitle"
      :visible.sync="isShow"
      @close="closeDialog"
      top="15vh"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="formContainer">
        <div class="tabs">
          <span
            :class="tabsActive === 0 ? 'active' : ''"
            @click="tabsActive = 0"
            >通用设置</span
          >
          <span
            :class="tabsActive === 1 ? 'active' : ''"
            @click="tabsActive = 1"
            >模块数据权限</span
          >
        </div>
      </div>
      <!--通用设置-->
      <div
        class="formContainer2"
        v-show="tabsActive === 0"
        @click="
          showTips = false
          showTips2 = false
        "
      >
        <div class="title">
          <span class="line"></span>
          <span>开启分享地图密码访问</span>
        </div>
        <div class="checkbox">
          <el-checkbox
            v-model="general.accessPasswordEnable"
            @change="changePsdCheck"
            >开启密码设置</el-checkbox
          >
          <span>注：密码设置后他人访问此分享地图时须输入密码</span>
        </div>
        <div class="input">
          <el-form
            :model="general"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
            v-if="general.accessPasswordEnable"
          >
            <el-form-item label="" prop="accessPassword">
              <el-input
                :type="isShowPassword ? 'text' : 'password'"
                @change="isChanged = true"
                v-model.trim="general.accessPassword"
                :minlength="4"
                :maxlength="12"
                show-word-limit
                placeholder="请输入4-12位密码（除空格外，区分字母大小写）"
              >
                <svg
                  class="show-password"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  slot="suffix"
                  @click="isShowPassword = !isShowPassword"
                >
                  <use
                    :xlink:href="
                      isShowPassword ? '#icon-browse' : '#icon-eye-close'
                    "
                  ></use>
                </svg>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="line2"></div>
        <div class="title">
          <span class="line"></span>
          <span>访问有效时长</span>
        </div>
        <div class="radio">
          <el-radio-group
            v-model="general.accessValidDays"
            @change="isChanged = true"
          >
            <el-radio :label="-1">永久有效</el-radio>
            <el-radio :label="30">30天</el-radio>
            <el-radio :label="7">7天</el-radio>
            <el-radio :label="1">1天</el-radio>
          </el-radio-group>
        </div>
        <div class="line2"></div>
      </div>
      <!--模块数据权限-->
      <div
        class="formContainer3"
        v-show="tabsActive === 1"
        @click="
          showTips = false
          showTips2 = false
        "
      >
        <div class="left">
          <ul class="SettingDialog-checkbox-group">
            <li
              :class="checkboxActive === 1 ? 'active' : ''"
              @click="checkboxActive = 1"
            >
              <el-checkbox
                v-model="modelData.layer"
                @change="
                  modelData.layer = true
                  isChanged = true
                "
                disabled
              ></el-checkbox>
              <span style="color: rgb(204, 204, 204)">图层管理</span>
              <i class="el-icon-arrow-right"></i>
            </li>
            <li
              :class="checkboxActive === 2 ? 'active' : ''"
              @click="checkboxActive = 2"
            >
              <el-checkbox
                v-model="modelData.viewpoint"
                @change="val=>{isChanged = true;checkedAllByPoint(val)}"
              ></el-checkbox>
              视点管理
              <i class="el-icon-arrow-right"></i>
            </li>
            <li
              :class="checkboxActive === 3 ? 'active' : ''"
              @click="checkboxActive = 3"
            >
              <el-checkbox
                v-model="modelData.path"
                @change="val=>{isChanged = true;checkedAllByPath(val)}"
              ></el-checkbox>
              路径规划
              <i class="el-icon-arrow-right"></i>
            </li>
          </ul>
        </div>
        <!--图层管理-->
        <div
          class="right"
          v-show="checkboxActive === 1"
          style="overflow-x: hidden"
        >
          <div class="title">
            <span class="line"></span>
            <span>图层列表</span>
          </div>
          <div class="checkbox">
            <el-checkbox
              v-model="modelData.layerListShow"
              @change="isChanged = true"
              >显示</el-checkbox
            >
          </div>
          <div class="line2"></div>
          <div class="title">
            <span class="line"></span>
            <span>隐藏标注资源</span>
          </div>
          <div class="checkbox">
            <el-checkbox
              v-model="modelData.markSourceDataShow"
              @change="isChanged = true"
              >图片/视频
              <span style="color: #6f7172"></span></el-checkbox
            >
            <el-checkbox
              v-model="modelData.markSourceAttachmentShow"
              @change="isChanged = true"
              >文档
              <span style="color: #6f7172"
                >（pdf）</span
              ></el-checkbox
            >
          </div>
          <div class="line2"></div>
          <div class="title">
            <span class="line"></span>
            <span>图层数据</span>
          </div>
          <el-tree
            :data="markerTreeData"
            ref="markerTree"
            :props="defaultProps"
            show-checkbox
            node-key="id"
            @check-change="isChanged = true"
            style="transform: translateX(5px)"
          >
            <span slot-scope="{ data }" class="custom-markerTree">
              <Icon
                type="small"
                name="icon-noodles-a"
                v-if="data.name !== '全选' && data.type === 'PLANE'"
              ></Icon>
              <Icon
                type="small"
                name="icon-dian"
                v-if="data.name !== '全选' && data.type === 'POINT'"
              ></Icon>
              <Icon
                type="small"
                name="icon-Line-a2"
                v-if="data.name !== '全选' && data.type === 'LINE'"
              ></Icon>
              <Icon
                type="small"
                name="icon-folder-b"
                v-if="data.name !== '全选' && !data.type"
              ></Icon>
              <span>{{ data.name }}</span>
            </span>
          </el-tree>
        </div>
        <!--视点管理-->
        <div class="right" v-show="checkboxActive === 2">
          <el-tree
            @check-change="checkChange"
            :data="viewTreeData"
            ref="viewTreeData"
            :props="defaultProps"
            show-checkbox
            node-key="id"
          ></el-tree>
          <el-tree
            @check-change="checkChange"
            :data="viewTreeData2"
            ref="viewTreeData2"
            :props="defaultProps"
            show-checkbox
            node-key="id"
          ></el-tree>
        </div>
        <!--路径规划-->
        <div class="right" v-show="checkboxActive === 3">
          <el-tree
            @check-change="checkChange2"
            :data="planTreeData"
            ref="planTreeData"
            :props="defaultProps"
            show-checkbox
            node-key="id"
          ></el-tree>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backMap" class="backBtn">
          <div class="tips" v-if="showTips && isChanged">
            当前设置未保存，再次点击关闭当前窗口
          </div>
          <span>返回地图分享</span>
        </el-button>
        <el-button type="primary" @click="resetSetting" class="resetBtn">
          <div class="tips" v-if="showTips2">再次点击还原默认设置</div>
          <span>还原默认设置</span>
        </el-button>
        <el-button type="primary" @click="onSubmit">应用生效</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getLayerTree,
  getViewPointList,
  getViewAnimationList,
  getRoutes,
  applicationEffect,
  getShareMapSetting
} from '@/api/mapManagement'
export default {
  name: 'SettingDialog',
  props: {},
  components: {},
  data () {
    return {
      isShow: false,
      loading: false,
      dialogTitle: '地图分享-高级设置',
      dialogType: '',
      tabsActive: 0,
      checkboxActive: 1,
      checked: false,
      radio: 7,
      showTips: false,
      showTips2: false,
      isShowPassword: false,
      rules: {
        accessPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 4,
            max: 12,
            message: '长度在 4 到 12 个字符',
            trigger: 'blur'
          }
        ]
      },
      markerTreeData: [
        {
          id: -1,
          name: '全选',
          children: []
        }
      ], // 图层数数据
      viewTreeData: [
        {
          id: -1,
          name: '视点管理',
          children: []
        }
      ], // 视点管理树数据
      viewTreeData2: [
        {
          id: -1,
          name: '视点动画',
          children: []
        }
      ], // 视点动画树数据
      planTreeData: [
        {
          id: -1,
          name: '全选',
          children: []
        }
      ], // 路径树数据
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      isCheckedAll: true, // 是否全选图层数据,
      general: {
        // 通用设置
        accessPasswordEnable: false,
        accessPassword: '',
        accessValidDays: -1
      },
      modelData: {
        // 模块设置
        layerListShow: true,
        markSourceAttachmentShow: true,
        markSourceDataShow: true,
        layer: true,
        viewpoint: true,
        path: true
      },
      isChanged: false,
      clickBtnCount: 0,
      cacheData: {}
    }
  },
  watch: {
    tabsActive (newValue, oldValue) {
      if (newValue === 1) {
        // this.checkedAll()
      }
    },
    checkboxActive (newValue, oldValue) {
      if (newValue === 1) {
        // this.checkedAll()
      }
    }
  },
  methods: {
    // 打开高级设置弹框
    open (shareId, mapId) {
      // console.log(shareId)
      this.isShow = true
      this.mapId = mapId
      this.isShowPassword = false
      this.shareId = shareId
      // 默认全选图层管理的图层数据
      this.$nextTick(async () => {
        await this.getLayerTree()
        await this.getViewPointList()
        await this.getViewAnimationList()
        await this.getRoutes()
        await this.getShareMapSetting()
      })
    },
    closeDialog () {
      this.isShow = false
      this.showTips = false
      this.showTips2 = false
      this.tabsActive = 0
      this.checkboxActive = 1
    },
    // 获取分享配置
    async getShareMapSetting () {
      const res = await getShareMapSetting(this.shareId)
      if (res.code === 200) {
        Object.keys(this.general).forEach((k) => {
          this.general[k] = res.data.general[k]
        })
        Object.keys(this.modelData).forEach((k) => {
          this.modelData[k] = res.data.data[k]
        })
        this.$nextTick(() => {
          this.$refs.markerTree.setCheckedKeys(res.data.data.layerIds)
          this.$refs.viewTreeData.setCheckedKeys(res.data.data.viewpointIds)
          this.$refs.viewTreeData2.setCheckedKeys(
            res.data.data.viewpointAnimationIds
          )
          this.$refs.planTreeData.setCheckedKeys(res.data.data.pathIds)
        })
        setTimeout(() => {
          this.isChanged = false
        }, 500)
      }
    },
    // 开启密码设置
    changePsdCheck (v) {
      this.isChanged = true
      if (!v) {
        this.general.accessPassword = ''
      }
    },
    // 返回地图分享
    backMap () {
      if (!this.isChanged) {
        this.closeDialog()
        return
      }
      if (this.showTips) {
        this.closeDialog()
      } else {
        this.showTips = true
        this.showTips2 = false
      }
    },
    // 还原默认设置
    resetSetting () {
      if (!this.showTips2) {
        this.showTips2 = true
      } else {
        Object.keys(this.general).forEach((k) => {
          this.general[k] = this.$options.data().general[k]
        })
        Object.keys(this.modelData).forEach((k) => {
          this.modelData[k] = this.$options.data().modelData[k]
        })
        this.$nextTick(() => {
          this.$refs.markerTree.setCheckedNodes(this.markerTreeData)
          this.$refs.viewTreeData.setCheckedNodes(this.viewTreeData)
          this.$refs.viewTreeData2.setCheckedNodes(this.viewTreeData2)
          this.$refs.planTreeData.setCheckedNodes(this.planTreeData)
        })
        this.isShow = false
        setTimeout(() => {
          this.onSubmit()
        }, 500)
      }
    },
    // 全选图层数据
    checkedAll () {
      if (this.isCheckedAll) {
        // 全选
        this.$nextTick(() => {
          this.$refs.markerTree.setCheckedNodes(this.markerTreeData)
          // this.$refs.viewTreeData.setCheckedNodes(this.viewTreeData)
          // this.$refs.viewTreeData2.setCheckedNodes(this.viewTreeData2)
          // this.$refs.planTreeData.setCheckedNodes(this.planTreeData)
        })
      } else {
        // 取消选中
        this.$nextTick(() => {
          this.$refs.markerTree.setCheckedKeys([])
        })
      }
    },
    // 全选视点数据
    checkedAllByPoint (checked) {
      this.isChanged = true
      if (checked) {
        // 全选
        this.$nextTick(() => {
          // this.$refs.markerTree.setCheckedNodes(this.markerTreeData)
          this.$refs.viewTreeData.setCheckedNodes(this.viewTreeData)
          this.$refs.viewTreeData2.setCheckedNodes(this.viewTreeData2)
          // this.$refs.planTreeData.setCheckedNodes(this.planTreeData)
        })
      } else {
        // 取消选中
        this.$nextTick(() => {
          this.$refs.viewTreeData.setCheckedKeys([])
          this.$refs.viewTreeData2.setCheckedKeys([])
        })
      }
    },
    // 全选路径规划数据
    checkedAllByPath (checked) {
      this.isChanged = true
      if (checked) {
        // 全选
        this.$nextTick(() => {
          // this.$refs.markerTree.setCheckedNodes(this.markerTreeData)
          // this.$refs.viewTreeData.setCheckedNodes(this.viewTreeData)
          // this.$refs.viewTreeData2.setCheckedNodes(this.viewTreeData2)
          this.$refs.planTreeData.setCheckedNodes(this.planTreeData)
        })
      } else {
        // 取消选中
        this.$nextTick(() => {
          this.$refs.planTreeData.setCheckedKeys([])
        })
      }
    },
    // 获取图层树数据
    async getLayerTree () {
      const res = await getLayerTree(
        {
          mapId: this.mapId
        },
        this.shareId
      )
      if (res.code === 200) {
        // const arr = res.data.layers.concat(res.data.children)
        this.markerTreeData[0].children = res.data.children
      }
    },
    // 获取视点管理列表
    async getViewPointList () {
      const res = await getViewPointList(
        {
          mapId: this.mapId
        },
        this.shareId
      )
      if (res.code === 200) {
        this.viewTreeData[0].children = res.data
      }
    },
    // 获取视点动画列表
    async getViewAnimationList () {
      const res = await getViewAnimationList(
        {
          mapId: this.mapId
        },
        this.shareId
      )
      if (res.code === 200) {
        this.viewTreeData2[0].children = res.data
      }
    },
    // 获取路径规划列表
    async getRoutes () {
      const res = await getRoutes(this.mapId, this.shareId)
      if (res.code === 200) {
        this.planTreeData[0].children = res.data.records
      }
    },
    // 应用生效
    async onSubmit () {
      if (this.general.accessPasswordEnable) {
        await this.$refs.ruleForm.validate()
      }
      this.modelData.layerIds = this.$refs.markerTree.getCheckedKeys() // 图层节点
      this.modelData.halfFolderIds = this.$refs.markerTree.getHalfCheckedKeys() // 文件夹半节点
      this.modelData.viewpointIds = this.$refs.viewTreeData.getCheckedKeys()
      this.modelData.viewpointAnimationIds =
        this.$refs.viewTreeData2.getCheckedKeys()
      this.modelData.pathIds = this.$refs.planTreeData.getCheckedKeys()
      const params = {
        mapId: this.mapId,
        version: this.version,
        data: this.modelData,
        general: this.general
      }
      const res = await applicationEffect(params, this.shareId)
      if (res.code === 200) {
        this.closeDialog()
        this.$message.success()
      }
    },
    checkChange (v) {
      this.isChanged = true
      if (
        this.$refs.viewTreeData.getCheckedKeys().length > 0 ||
        this.$refs.viewTreeData2.getCheckedKeys().length > 0
      ) {
        this.modelData.viewpoint = true
      }
    },
    checkChange2 (v) {
      this.isChanged = true
      if (this.$refs.planTreeData.getCheckedKeys().length > 0) {
        this.modelData.path = true
      }
    }
  },
  filters: {}
}
</script>

<style scoped lang="scss">
.SettingDialog {
  .formContainer {
    .tabs {
      width: 240px;
      height: 32px;
      background: #3d3e40;
      border: 1px solid #00a4f0;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      margin-bottom: 16px;
      > span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: #ffffff;
        display: inline-block;
        width: 50%;
        height: 100%;
        line-height: 30px;
        cursor: pointer;
        transition: all 0.3s;
        &.active {
          background: #00a4f0;
        }
      }
    }
  }
  .formContainer2 {
    width: 560px;
    height: 312px;
    background: #303133;
    border-radius: 6px;
    padding: 20px;
    box-sizing: border-box;
    text-align: left;
    .title {
      margin-bottom: 12px;
      > span {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #ffffff;
        display: inline-block;
      }
      .line {
        width: 3px;
        height: 10px;
        background: #ffffff;
        border-radius: 2px;
        margin-right: 8px;
      }
    }
    .checkbox {
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 11px;
      > span {
        font-size: 12px;
        font-family: Source Han Sans SC;
        font-weight: 300;
        color: rgba(242, 171, 63, 0.8);
      }
    }
    .input {
      padding: 0 10px;
      box-sizing: border-box;
      margin-bottom: 20px;
    }
    .radio {
      padding: 0 10px;
      box-sizing: border-box;
      margin-bottom: 20px;
    }
    .line2 {
      width: 520px;
      height: 1px;
      background-color: white;
      opacity: 0.1;
      margin-bottom: 16px;
    }
    .show-password {
      transform: translate(-6px, 1.5px);
    }
  }
  .formContainer3 {
    width: 560px;
    height: 315px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      width: 140px;
      height: 315px;
      background: #303133;
      border-radius: 6px;
      padding: 16px 8px;
      box-sizing: border-box;
      .SettingDialog-checkbox-group {
        list-style: none;
        margin: 0;
        padding: 0;
        > li {
          width: 124px;
          height: 32px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          cursor: pointer;
          color: white;
          font-size: 14px;
          padding-left: 13px;
          box-sizing: border-box;
          transition: all 0.3s;
          &:hover {
            background: #334966;
          }
          &.active {
            background: #334966;
          }
          .el-checkbox {
            width: 14px;
            height: 14px;
            line-height: 0;
            margin-right: 8px;
            transform: translateY(-2px);
          }
          > i {
            display: inline-block;
            transform: translateX(15px);
            color: rgba(232, 232, 232, 0.8);
            font-size: 12px;
          }
        }
      }
    }
    .right {
      width: 408px;
      height: 315px;
      background: #303133;
      border-radius: 6px;
      padding: 20px;
      box-sizing: border-box;
      text-align: left;
      overflow-y: auto;
      .title {
        margin-bottom: 12px;
        > span {
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          display: inline-block;
        }
        .line {
          width: 3px;
          height: 10px;
          background: #ffffff;
          border-radius: 2px;
          margin-right: 8px;
        }
      }
      .checkbox {
        padding-left: 10px;
        box-sizing: border-box;
        margin-bottom: 20px;
      }
      .line2 {
        width: 368px;
        height: 1px;
        background-color: white;
        opacity: 0.1;
        margin-bottom: 16px;
      }
    }
  }
}
</style>
<style lang="scss">
.SettingDialog {
  .customDialog {
    .el-dialog__body {
      padding-top: 16px;
    }
    .el-dialog {
      width: 600px;
    }
    .dialog-footer {
      > button {
        width: auto;
        margin-left: 12px;
        &:nth-child(2) {
          background-color: #e8a033 !important;
          border-color: #e8a033 !important;
        }
      }
      .backBtn,
      .resetBtn {
        position: relative;
        .tips {
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 300;
          color: #f2ab3f;
          position: absolute;
          top: -30px;
          width: 232px;
          height: 25px;
          background: url('../images/tip-a.png');
          line-height: 20px;
          text-align: center;
          left: -60px;
        }
      }
    }
    .el-radio-group {
      .el-radio {
        margin-right: 60px;
      }
    }
    .formContainer3 {
      .el-tree {
        background-color: rgba(255, 255, 255, 0) !important;
        .el-tree-node {
          background-color: rgba(255, 255, 255, 0) !important;
        }
        .el-tree-node:focus > .el-tree-node__content {
          background-color: rgba(255, 255, 255, 0) !important;
        }
        .el-tree-node__content {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .custom-markerTree {
            display: flex;
            align-items: center;
            .custom-icon {
              margin-right: 6px;
              margin-left: -6px;
              > svg {
                color: rgba(255, 255, 255, 0.3);
              }
            }
          }
        }
      }
    }
    .el-tree .el-tree-node.is-current > .el-tree-node__content:first-child {
      color: unset !important;
    }
    .el-checkbox .el-checkbox__input .el-checkbox__inner {
      border: 1px solid rgba(55, 56, 57, 0);
    }
  }
}
</style>
